import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';
import { createSequentialArray } from '@/utils/array';
import { classnames } from '@/utils/classnames';

interface IHintLoaderProps {
  className?: string;
}

export const HintLoader: FC<IHintLoaderProps> = ({ className }) => {
  return (
    <>
      {createSequentialArray(5).map((n) => (
        <div
          key={n}
          className={classnames('flex flex-col gap-[10px]', className)}
        >
          <Skeleton height={52} width={52} isCircle />
          <Skeleton height={16} radius={4} width={50} />
        </div>
      ))}
    </>
  );
};
